import { SamplePack } from '@arpeggi/shared'
import { useIsEditionHolder } from './useIsEditionHolder'

export const useIsSPEditionHolder = (sp: SamplePack) => {
  return useIsEditionHolder(sp.edition?.contractAddress, sp.edition?.chain)
}
